<elcia-card>
  <div class="flex flex-col gap-4">

    <!-- Section header, mirroring the product sections on the left column -->
    <div class="flex min-w-0 items-center gap-2.5">
      <span aria-hidden="true" class="pi pi-history flex-none text-sm text-[var(--p-surface-400)]"></span>
      <span class="min-w-0 text-lg font-bold">{{ 'product-customer.history.title' | translate }}</span>
      @if (history().length > 0) {
        <span
          class="flex-none rounded-full bg-[var(--p-surface-200)] px-2.5 py-0.5 text-xs text-[var(--p-surface-600)] tabular-nums">
          {{ history().length }}
        </span>
      }
    </div>

    @if (isLoading()) {
      <div class="flex items-center justify-center py-10">
        <elcia-loader/>
      </div>
    } @else if (history().length === 0) {
      <div class="flex flex-col items-center justify-center gap-2 py-10 text-[var(--p-surface-500)]">
        <span aria-hidden="true" class="pi pi-history text-xl"></span>
        <span class="text-sm">{{ 'product-customer.history.empty' | translate }}</span>
      </div>
    } @else {
      <!-- No gap between entries: the rail segments must join to form one continuous line -->
      <div class="flex flex-col">
        @for (entry of history(); track entry.id) {
          <elcia-customer-product-history-item
            (onSelect)="onSelect.emit($event)"
            [entry]="entry"
            [isLast]="$last"/>
        }
      </div>
    }

  </div>
</elcia-card>
